var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('loginbox'),_vm._v(" "),_c('detailbox',{attrs:{"title":'活动详情',"info":_vm.info.assess_info}}),_vm._v(" "),_c('infolist',{attrs:{"title":'出售账号',"type":2,"qq":_vm.info.qq_assess,"qqShow":_vm.info.display_qq_assess,"wechat":_vm.info.service_assess,"wechatShow":_vm.info.display_weixin_assess}}),_vm._v(" "),_c('detailbox',{attrs:{"title":'活动细则',"info":_vm.info.assess_rule}}),_vm._v(" "),_c('div',{staticClass:"bar"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ab0e401","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/evaluatepage/evaluatepage.vue
// module id = 495
// module chunks = 13